module.exports = __webpack_public_path__ + "assets/images/cosmote_4k.ed999d4310abebfc95c142bb32368dfe.png";